import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable, shareReplay } from 'rxjs';
import { IBlogIndex, IBlogPost, IBlogPostMeta } from '../interfaces/blog-post.interface';

@Injectable({ providedIn: 'root' })
export class BlogContentService {
  private http = inject(HttpClient);

  private index$?: Observable<IBlogIndex>;

  getIndex(): Observable<IBlogIndex> {
    if (!this.index$) {
      this.index$ = this.http
        .get<IBlogIndex>('/blog-data/index.json')
        .pipe(shareReplay({ bufferSize: 1, refCount: false }));
    }
    return this.index$;
  }

  getPosts(): Observable<IBlogPostMeta[]> {
    return this.getIndex().pipe(map((i) => i.posts));
  }

  getPost(slug: string): Observable<IBlogPost> {
    return this.http.get<IBlogPost>(`/blog-data/posts/${slug}.json`);
  }
}
